import React from "react";
import { Input, Row, Col } from "reactstrap";
import { useSpecificationContextState } from "./useSpecificationContextState";
import { useSpecificationContextUpdater } from "./useSpecificationContextUpdater";
import { DebounceForText } from "./";

export default function QCT6Group({ readOnlyPRP }) {
  const SpecContextState = useSpecificationContextState();
  const SpecContextUpdater = useSpecificationContextUpdater();
  const alignCenter = "d-flex justify-content-center align-items-center mb-3";

  let value = SpecContextState.specification.qcT6Note;
  const readOnly = readOnlyPRP === null || readOnlyPRP === undefined ? false : !readOnlyPRP;
  const display =
    SpecContextState.specification.qcT6Note !== "177 deg C for two minutes with 9 gram load" &&
    SpecContextState.specification.qcT6Note !== "177 deg C for two minutes with 50 gram load" &&
    SpecContextState.specification.qcT6Note !== "190 deg C for 15 minutes with 20 gram load";

  return (
    <Row>
      <Col>
        <Row>
          <Col
            xs={{ offset: 1, size: 12 }}
            xl={{ offset: 1, size: 5 }}
            xxl={{ offset: 1, size: 3 }}
          >
            <div className={alignCenter}>
              <Input
                type="radio"
                name="177 deg C for two minutes with 50 gram load"
                className="px-0 me-1 radio-color"
                checked={
                  value === "177 deg C for two minutes with 50 gram load"
                }
                onChange={() =>
                  SpecContextUpdater.onChange(
                    "qcT6Note",
                    "177 deg C for two minutes with 50 gram load"
                  )
                }
                disabled={readOnly}
              />
              <h5
                style={{ textAlign: "left", marginTop: "10px", color: "white" }}
              >
                177 deg C for two minutes with 50 gram load
              </h5>
            </div>
          </Col>
          <Col
            xs={{ offset: 1, size: 12 }}
            xl={{ offset: 1, size: 5 }}
            xxl={{ offset: 1, size: 3 }}
          >
            <div className={alignCenter}>
              <Input
                type="radio"
                name="190 deg C for 15 minutes with 20 gram load"
                className="px-0 me-1 radio-color"
                checked={value === "190 deg C for 15 minutes with 20 gram load"}
                onChange={() =>
                  SpecContextUpdater.onChange(
                    "qcT6Note",
                    "190 deg C for 15 minutes with 20 gram load"
                  )
                }
                disabled={readOnly}
              />
              <h5
                style={{ textAlign: "left", marginTop: "10px", color: "white" }}
              >
                190 deg C for 15 minutes with 20 gram load
              </h5>
            </div>
          </Col>
        </Row>

        <Row>
          <Col
            xs={{ offset: 1, size: 12 }}
            xl={{ offset: 1, size: 5 }}
            xxl={{ offset: 1, size: 3 }}
          >
            <div className={alignCenter}>
              <Input
                type="radio"
                name="177 deg C for two minutes with 9 gram load"
                className="px-0 me-1 radio-color"
                checked={value === "177 deg C for two minutes with 9 gram load"}
                onChange={() =>
                  SpecContextUpdater.onChange(
                    "qcT6Note",
                    "177 deg C for two minutes with 9 gram load"
                  )
                }
                disabled={readOnly}
              />
              <h5
                style={{ textAlign: "left", marginTop: "10px", color: "white" }}
              >
                177 deg C for two minutes with 9 gram load
              </h5>
            </div>
          </Col>
          <Col
            xs={{ offset: 1, size: 12 }}
            xl={{ offset: 1, size: 5 }}
            xxl={{ offset: 1, size: 3 }}
          >
            <div className={alignCenter}>
              <Input
                type="radio"
                name="Other"
                className="px-0 me-1 radio-color"
                checked={
                  value !== "177 deg C for two minutes with 9 gram load" &&
                  value !== "177 deg C for two minutes with 50 gram load" &&
                  value !== "190 deg C for 15 minutes with 20 gram load"
                }
                onChange={() =>
                  SpecContextUpdater.onChange("qcT6Note", "Other")
                }
                disabled={readOnly}
              />
              <h5
                style={{ textAlign: "left", marginTop: "10px", color: "white" }}
              >
                Other
              </h5>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={{ offset: 1, size: 12 }}
            xl={{ offset: 6, size: 6 }}
            xxl={{ offset: 4, size: 6 }}
          >
            <div className={alignCenter}>
              <DebounceForText
                onChangeString={"qcT6Note"}
                hideDisplayPRP={!display}
                valuePRP={SpecContextState.specification.qcT6Note}
                elementPRP={"textarea"}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
